import checkIcon from '../assets/map-check.png';
import checkIconActive from '../assets/map-check-checked.png';
// import test from '../assets/test.png';

export default class Filters {
  constructor(fields, visibleAssets, callback, resetCallback, translation) {
    this.callback = callback;
    this.visibleAssets = visibleAssets;
    this.filtersElement = document.createElement('div');
    this.filtersElement.classList.add('ac-map__filters');
    this.buttons = [];

    const { strings, language } = translation;

    fields.forEach(field => {
      const button = document.createElement('button');
      button.classList.add('ac-map__filter-button');
      button.innerText = strings[field.label][language];
      button.style.backgroundImage = `url('${checkIconActive}')`;

      button.addEventListener('click', () => {
        this.toggleFilter(field.value);

        if (button.classList.contains('ac-map__filter-button--disabled')) {
          button.classList.remove('ac-map__filter-button--disabled');
          button.style.backgroundImage = `url('${checkIconActive}')`;
        } else {
          button.classList.add('ac-map__filter-button--disabled');
          button.style.backgroundImage = `url('${checkIcon}')`;
        }
      });

      this.filtersElement.appendChild(button);
      this.buttons.push(button);
    });

    const resetButton = document.createElement('button');
    resetButton.classList.add('ac-map__filter-button');
    resetButton.classList.add('ac-map__filter-button--reset');
    resetButton.innerText = strings['resetmap'][language];
    resetButton.addEventListener('click', () => {
      resetCallback();

      this.visibleAssets = visibleAssets;
      this.buttons.forEach(button => button.classList.remove('ac-map__filter-button--disabled'));
    });

    this.filtersElement.appendChild(resetButton);
  }

  toggleFilter(value) {
    let updatedVisibilityAssets = this.visibleAssets;

    if (!updatedVisibilityAssets.includes(value)) {
      updatedVisibilityAssets.push(value);
    } else {
      updatedVisibilityAssets = updatedVisibilityAssets.filter(v => v !== value);
    }

    this.visibleAssets = updatedVisibilityAssets;
    this.callback(this.visibleAssets);
  }

  getElement() {
    return this.filtersElement;
  }
}
